import { FC } from 'react';
import BrandLoading from './BrandLoading';

/**
 * GlobalLoading - 全局/路由切换加载组件
 *
 * 使用 BrandLoading md 尺寸，位置与 Layout 内容区一致
 */
export const GlobalLoading: FC = () => {
    return (
        <div className="min-h-screen bg-page-base flex">
            {/* 模拟侧边栏占位 - 与 Layout 一致 */}
            <div className="hidden lg:block w-[220px] flex-shrink-0" />
            {/* 内容区居中 */}
            <div className="flex-1 flex flex-col">
                {/* 模拟顶部栏占位 */}
                <div className="h-[80px] flex-shrink-0" />
                {/* Loading 居中 */}
                <div className="flex-1 flex items-center justify-center">
                    <BrandLoading size="md" tip="加载中..." />
                </div>
            </div>
        </div>
    );
};

export default GlobalLoading;
